import { render, staticRenderFns } from "./ProposalShippingInfoView.vue?vue&type=template&id=2d3aba24&scoped=true&"
import script from "./ProposalShippingInfoView.vue?vue&type=script&lang=js&"
export * from "./ProposalShippingInfoView.vue?vue&type=script&lang=js&"
import style0 from "./ProposalShippingInfoView.vue?vue&type=style&index=0&id=2d3aba24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3aba24",
  null
  
)

export default component.exports